// @flow
export default {
  signIn: 'SIGN IN',
  adminSignIn: 'ADMIN PANEL',
  username: 'Username',
  password: 'Password',
  company: 'Company',
  forgotPassword: 'Forget your password?',
  poweredBy: 'Powered by',
  loading: 'Loading...',
  errorMessage: 'Username and/or password do not match. Please try again',
  errorMustNotEmpty: 'Username, password or company name cannot be empty',
  inputPhoneForm: {
    inputPhoneNumber: 'INPUT PHONE NUMBER',
    instructionText: 'SMS verification will be sent to your new number.',
    inputYourPhoneNumber: 'Input your phone number',
    submit: 'SUBMIT'
  },
  inputOTPForm: {
    securityCode: 'SECURITY CODE',
    instructionText: 'We have sent an SMS with a unique code to your listed number.',
    confirm: 'CONFIRM',
    smsSentTo: 'SMS Sent to +{0}',
    didNotReceiveSMS: 'Didn\'t receive the SMS?',
    resend: 'Resend',
    error: 'Verify OTP failed, please try again!',
    sending: 'Sending...'
  }
}
